import { render, staticRenderFns } from "./invitations.vue?vue&type=template&id=506ca990&"
import script from "./invitations.vue?vue&type=script&lang=js&"
export * from "./invitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports